import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewEncapsulation,
  Output, EventEmitter, ViewChild, TemplateRef, Input
} from '@angular/core';
import { UtilityService } from '@irb/irb-common/services/utility.service';
import { ValidationService } from '@irb/irb-common/services/validation.service';
import { IrbSettingsService } from '@irb/irb-settings/irb-settings.service';
import { IGlobalSettings, IGlobalSettingsSaveResponse, IPortfolioCustomCategory } from '@irb/irb-settings/irb-settings.model';
import { AppService } from '@irb/app.service';
import { IEvent, IrbSettingsEvents, IrbAppEvents } from '@irb-common/events';
import { PageService } from '@irb-common/services/page.service';
import {Subscription, Observable, of, ReplaySubject, interval} from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SettingsPage } from '@irb/irb-settings/irb-settings.page';
import { SettingsPortfoliosGridLayoutService } from '@irb/irb-settings/settings-portfolios/settings-portfolios.grid-layout.service';
import { CalltoactionService } from '@irb/irb-common/components/calltoaction/calltoaction.service';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { IrbAuthenticationService } from '@irb/irb-authentication/irb-authentication.service';
import { IrbAgGridExportService } from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service';
import {Router} from "@angular/router";
import {IAlertDialogData, IApplyFilterOnLanding} from "@irb/app.model";
import {MatDialogRef} from "@angular/material/dialog";
import {SettingsDialogComponent} from "@irb/irb-settings/settings-dialog/settings-dialog.component";
import {AnalyticsService} from "@irb-common/analytics/analytics.service";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {MatAccordion} from "@angular/material/expansion";

@Component({ standalone: false,
  selector: 'irb-settings-portfolios',
  templateUrl: './settings-portfolios.component.html',
  styleUrls: ['./settings-portfolios.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SettingsPortfoliosComponent implements SettingsPage<IGlobalSettings>, OnInit, OnDestroy {
  defaultExpandedPanels:Array<string> = ["HISTORY","GAINS_RESTRICTIONS","CUSTOM_CATEGORIES"];
  _globalSettings: IGlobalSettings;
  originalGlobalSettings: IGlobalSettings;
  _isModified: boolean;
  eventSubscription: Subscription;
  showUnsavedChangesWarning: boolean = false;
  grid: any;
  gridOptions: any;
  frameworkComponents: any;
  footerContent: string;
  private _portfolioCustomCategories: Array<any> = [];
  originalPortfolioCustomCategories: Array<any>;
  newPortfolioCustLabelAbbr: string;
  newPortfolioCustLabelDesc: string;
  newPortfolioCustLabelAbbrExists: boolean = false;
  faDownload = faDownload;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  customCategory: string;
  isadmin:boolean=false;
  @Output()
  closeModal: EventEmitter<any> = new EventEmitter<any>();
  isUiTest: boolean = false;
  checkSaveSub: Subscription;
  showCategoryMenuItem: boolean = false;
  gridHeight: string = '100%';
  isPortfolioCustLabelAbbrRequired: boolean = false;
  isNewPortfolioCustLabelAbbrRequired: boolean = false;
  @ViewChild('customLabelsPanel') customLabelsPanel: any;
  @Input('onFirstLoad') onFirstLoad: Function;
  @Output() onFirstLoadChange: EventEmitter<Function> = new EventEmitter<Function>();
  gainsThresholdIsCustom: boolean = false;
  gainsThresholdAmt: number;
  isEditGainThresholdFeatureFlagEnabled: boolean = false;

  /*validation*/
  labelNamesRegExp: string;
  validationErrors: string[];
  validationErrorTemplates: TemplateRef<any>[];
  @ViewChild("columnNameValidationErrorTemplate") columnNameValidationErrorTemplate: TemplateRef<any>;
  @ViewChild("labelNameValidationErrorTemplate") labelNameValidationErrorTemplate: TemplateRef<any>;
  @ViewChild("labelNameExistsValidationErrorTemplate") labelNameExistsValidationErrorTemplate: TemplateRef<any>;
  @ViewChild("labelNameInvalidCharValidationErrorTemplate") labelNameInvalidCharValidationErrorTemplate: TemplateRef<any>;
  @ViewChild("labelNameGridValidationErrorTemplate") labelNameGridValidationErrorTemplate: TemplateRef<any>;
  @ViewChild("labelNameInput") labelNameInput: any;
  @ViewChild("labelDescriptionInput") labelDescriptionInput: any;
  @ViewChild("columnNameInput") columnNameInput: any;
  @ViewChild("gainsThresholdAmtInput") gainsThresholdAmtInput: any;
  @ViewChild("gainsThresholdAmtValidationErrorTemplate") gainsThresholdAmtValidationErrorTemplate: TemplateRef<any>;

  /*dropdowns*/
  portfolioCapitalGainSetting: IDropdownItem;
  static gainsControlSettingOptions: Array<IDropdownItem> = [];
  @ViewChild('gainsControlSetting') gainsControlSetting: DropdownFilterComponent;
  @ViewChild('accordion') accordion: MatAccordion;
  ENABLE_SETTINGS_HIST = false;

  constructor(
    public iss: IrbSettingsService, 
    private cdr: ChangeDetectorRef, 
    private util: UtilityService, 
    private as: AppService, 
    private ps: PageService,
    private vs: ValidationService,
    private spgls: SettingsPortfoliosGridLayoutService,
    private ctas: CalltoactionService,
    public ias:IrbAuthenticationService,
    public ges: IrbAgGridExportService,private router: Router,
    public dialogRef: MatDialogRef<SettingsDialogComponent>,
    public ats: AnalyticsService) {
    this.ats.trackGlobalSettingsPortfoliosEvent();
      this.eventSubscription = this.as.getEvents().subscribe((s) => { this.processEvent(s); });
      this.isEditGainThresholdFeatureFlagEnabled = this.as.getItem('IRB_APP_CONFIG')?.featureFlags.ENABLE_GAINS_THRESHOLD || false;
      this.ENABLE_SETTINGS_HIST = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_SETTINGS_HIST || false;
    }

  ngOnInit() {
    this.iss.getGlobalSettings().pipe(takeUntil(this.destroyed$)).subscribe((data: IGlobalSettings) => {
      this.globalSettings = data;
      this.isadmin = this.globalSettings.isAdminUser;
      if (!this.ENABLE_SETTINGS_HIST) {
        this.defaultExpandedPanels = this.defaultExpandedPanels.filter(p => p !== 'HISTORY');
      }
      this.iss.loadExpansionState(this.defaultExpandedPanels.length,"settings-portfolios",this.defaultExpandedPanels);
      if (this.ENABLE_SETTINGS_HIST) {
        this.iss.updateExpansionState('HISTORY','closed');
      }

      if (SettingsPortfoliosComponent.gainsControlSettingOptions.length < 3) {
        this.iss.getGainsControlsDropDown().subscribe((dropDownData: string[]) => {
          SettingsPortfoliosComponent.gainsControlSettingOptions = [];
          dropDownData.forEach(dropDownItem => {
            SettingsPortfoliosComponent.gainsControlSettingOptions.push({
              name: dropDownItem,
              value: dropDownItem
            });
          });
        });
      }

      this.portfolioCapitalGainSetting = {
        name: data.gainsControlSetting,
        value: data.gainsControlSetting
      } as IDropdownItem;

      this.gridOptions = {
              columnDefs: this.spgls.getColumnDefs(this),
              floatingFilter: false,
              context: {componentParent: this},
              overlayNoRowsTemplate: "<span class='ag-overlay-message'>No custom values defined.</span>",
              suppressHorizontalScroll: true
      };

      if(this.onFirstLoad) {
        this.onFirstLoad();
        this.onFirstLoadChange.emit(null);
      }

      this.globalSettings.gainsThresholdAmt = this.globalSettings.gainsThresholdAmt || 0;
      this.gainsThresholdIsCustom = this.globalSettings.gainsThresholdAmt != 0;
      this.gainsThresholdAmt = (this.globalSettings.gainsThresholdAmt > 0) ? this.globalSettings.gainsThresholdAmt : 1;
      this.frameworkComponents = this.spgls.getFrameworkComponents();
      this.cdr.detectChanges();
    });

    this.ps.deserializePageState(this.as.getFromSession("pageState"), ["accountGridDiv"]);
    const dialogData: any = this.iss.getDialogData();

    if (dialogData && dialogData.dropdownSearchValue && dialogData?.type ==='portfolioCategory') {
      this.newPortfolioCustLabelAbbr = dialogData.dropdownSearchValue;
    }

    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.eventSubscription.unsubscribe();
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onGridReady(params: any) {
    this.grid = params;
    
    this.loadGrid(false);
    this.load(this.globalSettings);
    this.customCategory = this.globalSettings.portfolioCustLabelAbbr;
  }

  onGridChange(event: any) {
    let msg: string;
    const cc = {
      valueLabel: event.data.valueLabel,
      categoryName: event.data.categoryName,
      categoryId: event.data.categoryId,
      isSecurityPage: false,
      globalSettingsId:	this.globalSettings.globalSettingsId,
      environmentId: this.globalSettings.environmentId
    } as IPortfolioCustomCategory;
    
    if(this.checkIfPortfolioCustLabelAbbrExists(cc.valueLabel, cc.categoryId)) {
      msg = cc.valueLabel + " is already in use."
    } else if(cc.valueLabel.length == 0) {
      msg = "The 'Label Name' field cannot be empty";
    } else {
      this.globalSettings.newCustCatagList = this.globalSettings.newCustCatagList.filter((x: any) => x.categoryId != cc.categoryId);
      this.globalSettings.newCustCatagList.push(cc);
      
      this.onInputChange();
      this.updateGrid();
      return;
    }

    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dType: "ERROR",
      altMsgHTML: msg,
      onProceed: () => {
        this.revertGrid();
      }
    } as IAlertDialogData);
  }

  onInputChange() {
    window.setTimeout(() => {
      this.isModified = !this.util.compare(this.originalGlobalSettings,this.globalSettings);
      this.as.fireEvent((this.isModified) ? IrbSettingsEvents.IS_MODIFIED : IrbSettingsEvents.IS_NOT_MODIFIED);
      this.showUnsavedChangesWarning = false;
      this.validateInput().subscribe(_validationErrors => {});
      this.cdr.detectChanges();
    });
  }

  setPortfolioCapitalGains(searchStr: any) {
    this.gainsControlSetting.set(DropdownFilterComponent.getFilteredList(searchStr, SettingsPortfoliosComponent.gainsControlSettingOptions));
  }

  onGainRestrictionChange() {
    this.globalSettings.gainsControlSetting = this.portfolioCapitalGainSetting.value;
    this.onInputChange();
  }

  validateInput(): Observable<string[]> {
    this.validationErrors = [];
    this.validationErrorTemplates = [];

    if(this.columnNameInput?.inputControl.invalid) {
      this.validationErrors.push("");
      this.validationErrorTemplates.push(this.columnNameValidationErrorTemplate);
    }

    if(this.gainsThresholdIsCustom && this.gainsThresholdAmtInput?.inputControl.invalid) {
      this.validationErrors.push("");
      this.validationErrorTemplates.push(this.gainsThresholdAmtValidationErrorTemplate);
    }

    let gridErrors = this.portfolioCustomCategories?.filter((x: any) => 
        x.valueLabel?.includes("^") || 
        x.valueLabel?.length == 0 || 
        x.valueLabel?.length > 25 ||     
        x.categoryName?.length > 50 || 
        (x.valueLabel?.length > 0 && "+-=@".includes(x.valueLabel?.charAt(0))) || 
        (x.categoryName?.length > 0 && "+-=@".includes(x.categoryName?.charAt(0)))
    );
	  
    if(gridErrors?.length > 0) {
      this.validationErrors.push("");
      this.validationErrorTemplates.push(this.labelNameGridValidationErrorTemplate);
    }

    if (!this.isUiTest)
      this.cdr.detectChanges();
    return of(this.validationErrors);
  }

  load(data: IGlobalSettings) {
    this.globalSettings = data;
    this.globalSettings.currentSetting = "portfolioView";
    this.globalSettings.newCustCatagList = [];
    this.globalSettings.deletedCustCatagList = [];
    this.originalGlobalSettings = this.util.clone(this.globalSettings);
    this.isModified = false;
    this.showUnsavedChangesWarning = false;
    this.as.fireEvent(IrbSettingsEvents.IS_NOT_MODIFIED);
    this.updateGridFooter();
    this.cdr.detectChanges();
  }

  loadGrid(isAfterSave: boolean) {
    this.iss.getPortfolioCustCategorySettings().pipe(takeUntil(this.destroyed$)).subscribe((data: Array<IPortfolioCustomCategory>) => {
      this.portfolioCustomCategories = data;
      this.originalPortfolioCustomCategories = this.util.clone(this.portfolioCustomCategories);
      this.updateGrid();
      if (isAfterSave) {
        this.as.fireEvent(IrbSettingsEvents.SAVE_SUCCESS, "Portfolio settings were updated.");
        this.triggerNewItemToDropdown();
      }
    });
  }

  updateGrid() {
    if (this.grid && this.grid.api) {
      this.grid.api.setGridOption('rowData', this.portfolioCustomCategories);
      this.updateGridFooter();

      if(this.portfolioCustomCategories.length < 10) {
        this.gridHeight = "150px";
      } else {
        this.gridHeight = "350px";
      }
    }
  }

  updateGridFooter() {
    if (this.globalSettings && this.grid && this.grid.api) {
      this.footerContent = this.grid.api.getDisplayedRowCount() + " Labels";
      this.cdr.detectChanges();
    }
  }

  save() {
    if(!this.isPortfolioCustLabelAbbrRequired) {
      this.isPortfolioCustLabelAbbrRequired = true;
      this.cdr.detectChanges();
    }
    if(this.globalSettings?.portfolioCustLabelAbbr) {
      this.globalSettings.portfolioCustLabelAbbr = this.globalSettings.portfolioCustLabelAbbr.trim() || "";
    }

    setTimeout(() => {
      this.validateInput().subscribe(validationErrors => {
        if(validationErrors.length === 0) {
          this.as.fireEvent(IrbSettingsEvents.SAVE_START);
          const dialogData: any = this.iss.getDialogData();
          if (dialogData && dialogData?.type ==='portfolioCategory') {
            if(this.globalSettings?.newCustCatagList) {
              dialogData.newPortfolioCategoryItemsAdded = JSON.parse(JSON.stringify(this.globalSettings?.newCustCatagList));
              this.iss.setDialogData(dialogData);
            }
          }
          this.iss.saveSecurityAndPortfolioGlobalSettings(this.globalSettings).subscribe((data: any) => {
            const response = data as IGlobalSettingsSaveResponse;

            if(response.responseStatus == "SUCCESS") {
              if(response.responseUtilityMap != null) {
                //TODO: Show validation warning
              } else {
                this.iss.getGlobalSettings().pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
                  this.loadGrid(true);
                  this.load(data as IGlobalSettings);
                  this.customCategory = this.globalSettings.portfolioCustLabelAbbr;
                  if (!dialogData || !dialogData.dropdownSearch) {
                    this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
                  }

                  this.as.fireEvent(IrbSettingsEvents.UPDATE, data);
                });
              }
            } else {
              this.as.fireEvent(IrbSettingsEvents.SAVE_ERROR);
            }
          },() => {
            this.as.fireEvent(IrbSettingsEvents.SAVE_ERROR);
          });
        }
      });
    });
  }

  revert() {
    if(this.isModified) {
      this.load(this.originalGlobalSettings);
    }
  }

  revertGrid() {
    this.portfolioCustomCategories = this.util.clone(this.originalPortfolioCustomCategories);
    this.updateGrid();
  }

  processEvent(event: IEvent) {
    switch(event.type) {
      case IrbSettingsEvents.SAVE: 
        this.save();
        break;
      case IrbSettingsEvents.UNSAVED_CHANGES:
        if(this.isModified) {
          this.showUnsavedChangesWarning = true;
          this.cdr.detectChanges();
        }
        break;
      case IrbSettingsEvents.REVERT_CHANGES:
        this.revert();
        break;
      case IrbSettingsEvents.EXPAND_CUSTOM_LABELS:
        this.customLabelsPanel.expanded = true;
        break;
    }
  }

  disableDelete(_params :any) {
    return this.isadmin;
  }

  toggleCategoryMenuItem() {
    this.showCategoryMenuItem = !this.showCategoryMenuItem;

    if(!this.showCategoryMenuItem) {
      this.newPortfolioCustLabelAbbr = '';
      this.isNewPortfolioCustLabelAbbrRequired = false;
      this.newPortfolioCustLabelAbbrExists = false;
      this.validateCategoryMenuItem();
    }
  }

  validateCategoryMenuItem(): boolean {
    this.validationErrorTemplates = [];

    if((!this.newPortfolioCustLabelAbbr || this.newPortfolioCustLabelAbbr?.length == 0) && this.isNewPortfolioCustLabelAbbrRequired) {
      this.validationErrorTemplates.push(this.labelNameValidationErrorTemplate);
      return false;
    }

    if(this.newPortfolioCustLabelAbbrExists) {
      this.validationErrorTemplates.push(this.labelNameExistsValidationErrorTemplate);
      return false;
    }

    if(this.newPortfolioCustLabelAbbr?.includes("^")) {
      this.validationErrorTemplates.push(this.labelNameInvalidCharValidationErrorTemplate);
      return false;
    }

    return true;
  }

  addCategoryMenuItem() {
    this.isNewPortfolioCustLabelAbbrRequired = true;
    this.newPortfolioCustLabelAbbr = this.newPortfolioCustLabelAbbr?.trim() || "";
    this.newPortfolioCustLabelDesc = this.newPortfolioCustLabelDesc?.trim() || "";
    this.newPortfolioCustLabelAbbrExists = this.checkIfPortfolioCustLabelAbbrExists(this.newPortfolioCustLabelAbbr);

    if(this.newPortfolioCustLabelAbbrExists) {
      let a = this.portfolioCustomCategories.map(a => a.valueLabel);
      this.labelNamesRegExp = "^(?!(" + a.join("|") + ")$).*$";
    } else if(this.newPortfolioCustLabelAbbr.includes("^")) {
      this.labelNamesRegExp = "^[^\^]+$";
    }

    if(this.validateCategoryMenuItem()) {
      this.isNewPortfolioCustLabelAbbrRequired = false;

      const cc = {
        valueLabel: this.newPortfolioCustLabelAbbr,
        categoryName: this.newPortfolioCustLabelDesc,
        isSecurityPage: false,
        globalSettingsId:	this.globalSettings.globalSettingsId,
        environmentId: this.globalSettings.environmentId,
        categoryId: (new Date()).getTime() * -1
      } as IPortfolioCustomCategory;

      this.globalSettings.newCustCatagList.push(cc);
      this.portfolioCustomCategories.push(cc);

      this.onInputChange();
      this.updateGrid();
      const dialogData: any = this.iss.getDialogData();
      if (dialogData && dialogData?.type ==='portfolioCategory') {
        dialogData.dropdownSearchValue = this.newPortfolioCustLabelAbbr;
        this.iss.setDialogData(dialogData);
      }
      this.newPortfolioCustLabelAbbr = null;
      this.newPortfolioCustLabelDesc = null;
      this.cdr.detectChanges();
    }
  }

  deleteCategoryMenuItem(cc: any) {
    for(let i = 0; i < this.portfolioCustomCategories.length; i++) {
      if(this.portfolioCustomCategories[i].categoryId == cc.categoryId) {
        this.portfolioCustomCategories.splice(i,1);
        break;
      }
    }

    if(cc.categoryId > 0) {
      this.globalSettings.deletedCustCatagList.push(cc);
    } else {
      this.globalSettings.newCustCatagList = this.globalSettings.newCustCatagList.filter((x: any) => x.categoryId != cc.categoryId);
    }

    this.onNewPortfolioCustLabelAbbrChange();
    this.onInputChange();
    this.updateGrid();
  }

  deleteAllCategoryMenuItems() {
    for(let i = 0; i < this.portfolioCustomCategories.length; i++) {
      if(this.portfolioCustomCategories[i].categoryId > 0) {
        this.globalSettings.deletedCustCatagList.push(this.portfolioCustomCategories[i]);
      }
    }

    this.globalSettings.newCustCatagList = [];
    this.portfolioCustomCategories = [];
    this.onNewPortfolioCustLabelAbbrChange();
    this.onInputChange();
    this.updateGrid();
  }

  cancelDelete() {
    this.ctas.remove();
  }

  onNewPortfolioCustLabelAbbrChange() {
    this.newPortfolioCustLabelAbbrExists = false;
    this.labelNamesRegExp = null;
    this.validateCategoryMenuItem();
  }


  onApplyToAllPortfolios() {
    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
      dTitle: "Apply to All Portfolios?",
      altMsgHTML: "<div class='block'>Applying this setting will update all iRebal portfolios.</div>",
      dCancelBtnLabel: "Cancel",
      dProceedBtnLabel: "Yes, Apply to All Portfolios",
      onProceed: () => {
        this.applyToAllPortfoliosExecute();
      }
    } as IAlertDialogData);
  }

  applyToAllPortfoliosExecute() {
    this.as.fireEvent(IrbSettingsEvents.SAVE_START);
    this.iss.savePortfoliosGainCtrlSettingsAsync(this.globalSettings).subscribe((data: any) => {
      const response = data as IGlobalSettingsSaveResponse;

      if(response.responseStatus == "SUCCESS" && response.responseUtilityMap?.statusId) {
        this.applyToAllPortfoliosAsyncStatus(response.responseUtilityMap.statusId);
      } else {
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'error',
          summary: 'Apply To All Portfolios Failed',
          detail: "An error occurred processing your request."
        });
      }
    },() => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });
  }

  applyToAllPortfoliosAsyncStatus(importStatusId: string) {
    const intervalValue = this.isUiTest ? 0 : 3000;
    this.checkSaveSub = interval(intervalValue).subscribe(() => {
      this.iss.savePortfoliosGainCtrlSettingsStatus(importStatusId).subscribe((response: any) => {
        if (response.responseUtilityMap?.reqStatus?.toUpperCase() === "COMPLETED") {
          this.checkSaveSub.unsubscribe();
          this.applyToAllPortfoliosComplete();
        } else if(response.responseStatus !== "SUCCESS" ||
          (response.responseUtilityMap?.requestStatus && response.responseUtilityMap?.requestStatus?.toUpperCase() === "FAILED")) {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: 'Apply To All Portfolios Failed',
            detail: "An error occurred processing your request."
          });
          this.checkSaveSub.unsubscribe();
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        } else if(response.responseUtilityMap?.actionStatus?.reqStatus?.toUpperCase() === "IN_PROGRESS") {
        }
      }, () => {
        this.checkSaveSub.unsubscribe();
      });
    });
  }

  applyToAllPortfoliosComplete() {
    this.iss.getGlobalSettings().pipe(takeUntil(this.destroyed$)).subscribe((data: any) => {
      this.loadGrid(true);
      this.load(data as IGlobalSettings);
      this.customCategory = this.globalSettings.portfolioCustLabelAbbr;
	    this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
    });
  }
  
  onClickGoToPortfolios() {
    this.as.fireEvent(IrbSettingsEvents.NAVIGATE, {url: "/clients/portfolios"});
  }

  checkIfPortfolioCustLabelAbbrExists(s: string, id?: number): boolean {
    let b = false;

    this.portfolioCustomCategories.forEach(cc => {
      if(cc.valueLabel == s && !id) {
        b = true;
      } else if(cc.valueLabel == s && id && cc.categoryId != id) {
        b = true;
      }
    });

    return b;
  }

  export() {
    if(this.portfolioCustomCategories?.length == 0) {
      this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
          msg: "There are no labels to export."
      } as IAlertDialogData);
      return;
    }

    let sortModel: any = [];
    let columnWithSort = this.grid.api.getColumnState().filter((col:any) => col.sort !== null);
    if (columnWithSort) {
      sortModel = columnWithSort;
    }

    for(let i = 0; i < sortModel.length; i++) {
      this.portfolioCustomCategories.sort(function(a: any, b: any) {
        const x = (sortModel[i].sort === "asc") ? a[sortModel[i].colId] : b[sortModel[i].colId];
        const y = (sortModel[i].sort === "asc") ? b[sortModel[i].colId] : a[sortModel[i].colId];
        if(typeof x === "string" && typeof y === "string") {
          return ((x.toLowerCase() < y.toLowerCase()) ? -1 : ((x.toLowerCase() > y.toLowerCase()) ? 1 : 0));
        } else if(typeof x === "number" && typeof y === "number") {
          return x - y;
        } else if (x === null) {
          return (sortModel[i].sort === "asc") ? -1 : 1;
        } else if (y === null) {
          return (sortModel[i].sort === "asc") ? 1 : -1;
        }
      });
    }

    const s = JSON.stringify(this.portfolioCustomCategories);
    this.ges.setPrefix("Portfolio_custom_label_settings", "csv");
    this.iss.exportPortfolios(s).subscribe((res: Blob) => {
      this.ges.download(res);
    });
  }

  getRowCount() {
    return this.portfolioCustomCategories.length;
  }

  get globalSettings() {
    return this._globalSettings;    
  }

  set globalSettings(newGlobalSettings: IGlobalSettings) {
    this._globalSettings = newGlobalSettings;
  }

  get isModified() {
    return this._isModified;
  }

  set isModified(newIsModified: boolean) {
    this._isModified = newIsModified;
  }

  public get portfolioCustomCategories(): Array<IPortfolioCustomCategory> {
    return this._portfolioCustomCategories;
  }

  public set portfolioCustomCategories(value: Array<IPortfolioCustomCategory>) {
    this._portfolioCustomCategories = value;
  }

  showPortfolioDetails(data: any) {
    const state: IApplyFilterOnLanding = {
      isUpdatRequired: true,
      filterModel:
        { name: 'valueLabel', value: data.valueLabel,isUpdatRequired: true}
    } as IApplyFilterOnLanding;
    // console.log('Portfolio Details', state);
    this.as.fireEvent(IrbSettingsEvents.SHOW_PORTFOLIOS_BY_CATEGORY,state);
    this.router.navigateByUrl('/clients/portfolios', { state: state });
    this.closeModal.next(true);
  }

  triggerNewItemToDropdown() {
    const dialogData: any = this.iss.getDialogData();
    if (dialogData && dialogData.dropdownSearchValue && dialogData?.type==='portfolioCategory') {
      let newPortfolioCategoryItemsAdded = dialogData.newPortfolioCategoryItemsAdded;
      delete dialogData.newPortfolioItemsAdded;

      let newPortfolioCategoryItems: any [] = [];
      if(newPortfolioCategoryItemsAdded && newPortfolioCategoryItemsAdded.length > 0) {
        newPortfolioCategoryItemsAdded.forEach((portCategory:any) => {
          const newPortCatItem: any = this.portfolioCustomCategories.filter((ctgr: any) => {
            return ctgr.valueLabel === portCategory.valueLabel;
          });
          if (newPortCatItem && newPortCatItem.length !== 0) {
            const newPortCat: any = {
              custCatId: newPortCatItem[0].categoryId,
              custCatName: newPortCatItem[0].valueLabel,
              custCatDesc: newPortCatItem[0].categoryName
            };
            newPortfolioCategoryItems.push(newPortCat);
          }
        });
      }
      const newItem: any = this.portfolioCustomCategories.filter((ctgr: any) => {
        return ctgr.valueLabel === dialogData.dropdownSearchValue;
      });

      if (newItem && newItem.length !== 0) {
        const newCat: any = {
          custCatId: newItem[0].categoryId,
          custCatName: newItem[0].valueLabel,
          custCatDesc: newItem[0].categoryName
        };
        let isAddedtoList = newPortfolioCategoryItems.filter((x:any)=>{
          return x.custCatId === newCat.custCatId;
        });
        if(!(isAddedtoList && isAddedtoList.length > 0)) {
          newPortfolioCategoryItems.push(newCat)
        }
        const newCatDD: any = [{
          name: newItem[0].valueLabel,
          value: newItem[0].categoryId
        }];
        dialogData.newItemsForDD = newCatDD;
      }
      dialogData.newItems = newPortfolioCategoryItems;
      this.as.fireEvent(IrbSettingsEvents.PORTFOLIO_CATEGORY_UPDATED, dialogData);
      this.dialogRef.close();
    }
  }

  onGainsThresholdIsCustomChange() {    
    if(!this.gainsThresholdIsCustom) {
      this.globalSettings.gainsThresholdAmt = 0;
      this.onInputChange();
    } else {
      this.onGainsThreshholdAmtChange(true);
    }
  }

  onGainsThreshholdAmtChange(resetToZero: boolean = false) {
    if(!this.gainsThresholdAmtInput?.inputControl.invalid) {
      this.gainsThresholdAmt = (resetToZero) ? 0 : this.gainsThresholdAmt;
      this.globalSettings.gainsThresholdAmt = this.gainsThresholdAmt;
    }    
    
    this.onInputChange();
  }

  focusLabelNameInput() {
    this.labelNameInput.inputField.nativeElement.focus();
  }

  focusColumnNameInput() {
    this.columnNameInput.inputField.nativeElement.focus();
  }

  focusLabelDescriptionInput() {
    this.labelDescriptionInput.inputField.nativeElement.focus();
  }
}
